import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { AppBarOption } from "./AppBarOption";
import { AppBarNotification } from "./AppBarNotification";
import "../0.styles.css";
import {
  AppBar,
  Collapse,
  Grid,
  Link,
  ListItem,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { config, functions, instance, validateFunction } from "./config";
import { DialogAlert } from "./DialogAlert";
import { useAuth } from "./AuthContext";
import { useEffect, useState } from "react";

const settings = [
  {
    name: "Mi cuenta",
    link: "/MiCuenta",
  } /* , {name:'Cerrar sesión', link:'/Login'} */,
];

function AppBarComponent() {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [validtoken, setValidToken] = useState(false);
  const [dialog, setDialog] = useState({ title: "", text: "" });
  const [openDialog, setOpenDialog] = useState(false);
  const { user, logout } = useAuth();
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [desktopPages, setDesktopPages] = useState([]);
  const [mobilePages, setMobilePages] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleChange = () => {
    setChecked((prev) => !prev);
    document.querySelector(".MobileMenuContainer").classList.toggle("inactive");
    if (
      document
        .querySelector(".MobileMenuContainer")
        .classList.contains("inactive")
    ) {
      for (
        var i = 2;
        i < document.querySelector("#root").childNodes.length;
        i++
      ) {
        document.querySelector("#root").childNodes[i].style.display = "";
      }
    } else {
      for (
        var i = 2;
        i < document.querySelector("#root").childNodes.length;
        i++
      ) {
        document.querySelector("#root").childNodes[i].style.display = "none";
      }
    }
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
    document.querySelector(".MobileMenuContainer").classList.toggle("inactive");
    if (
      document
        .querySelector(".MobileMenuContainer")
        .classList.contains("inactive")
    ) {
      for (
        var i = 2;
        i < document.querySelector("#root").childNodes.length;
        i++
      ) {
        document.querySelector("#root").childNodes[i].style.display = "";
      }
    } else {
      for (
        var i = 2;
        i < document.querySelector("#root").childNodes.length;
        i++
      ) {
        document.querySelector("#root").childNodes[i].style.display = "none";
      }
    }
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
    setSelectedIndex(-1);
  };
  const handleLogOut = () => {
    logout();
    navigate("/Login");
  };

  const handleClick2 = (index) => {
    console.log('index seleccionado es ', index);
    setSelectedIndex(index);
    localStorage.setItem('selectedIndex', index);
  }

  const pages = [
    {
      name: "Administración",
      pages: [
        {
          name: "Usuarios del sistema",
          link: "/UsuariosDelSistema",
          mobile: true,
        },
        {
          name: "Roles",
          link: "/Roles",
          mobile: true,
          access: functions.ManageRolesAndFunctions,
        },
        {
          name: "Localidades / Centros de costo",
          link: "/Localidades",
          mobile: true,
        },
        {
          name: "Instrucciones de formularios",
          link: "/InstruccionesFormulario",
          mobile: true,
          access: functions.ManageInstrucciones,
        },
        {
          name: "UPSE-4",
          link: "#",
          mobile: true,
          access: functions.ManageCategoriaBeneficiario,
          childs: [
            { name: "Categorías de beneficiarios", link: "/CategoriasBeneficiario" },
          ],
        },
        {
          name: "UPSE-8",
          link: "#",
          mobile: true,
          access: functions.ManageUPSE8Configuracion,
          childs: [
            { name: "Configuración de plazos", link: "/UPSE8Configuracion" },
          ],
        },
      ],
    },
    {
      name: "Catálogos",
      pages: [
        {
          name: "Productos",
          link: "#",
          mobile: true,
          childs: [
            {
              name: "Productos",
              link: "/Productos",
            },
            {
              name: "Subproductos",
              link: "/SubProductos"
            },
            {
              name: "Cultivos",
              link: "/Cultivos"
            },
            {
              name: "Cultivar",
              link: "/Cultivar"
            }
          ],
        },
        {
          name: "Unidad de medida",
          link: "#",
          mobile: true,
          childs: [
            {
              name: "Categorías",
              link: "/Categoria"
            },
            {
              name: "Unidades de medida",
              link: "/Unidades"
            }
          ]
        },
        {
          name: "Ejes",
          link: "#",
          mobile: true,
          childs: [
            {
              name: "Tipos de ejes",
              link: "/TipoDeEje"
            },
            {
              name: "Ejes",
              link: "/Ejes"
            }
          ]
        }
      ],
    },
    {
      name: "Planificación",
      pages: [
        /*{
          name: "UPSE 1 Actividades",
          link: "#",
          mobile: true,
          //access: functions.CreateUPSE,
          childs: [
            {
              name: "UPSE-1",
              link: "/UPSE1Agregar"
            },
            {
              name: "Buscador",
              link: "/UPSEBuscador"
            }
          ]
        },*/
        {
          name: "UPSE 2 Metas físicas",
          link: "/UPSE2Agregar",
          mobile: false,
          access: functions.CreateUPSE2,
          /*childs: [
            {
              name: "Agregar planificación",
              link: "/UPSE2Agregar"
            },
            {
              name: "Ver fomularios",
              link: "/UPSE2"
            }
          ]*/
        },
      ],
    },
    {
      name: "Ejecución mensual",
      pages: [
        /*{
          name: "UPSE 1 Actividades",
          link: "#",
          mobile: true,
          access: functions.CreateActivity,
        },*/
        {
          name: "UPSE 4 Metas físicas",
          link: "/UPSE4Agregar",
          mobile: true,
          access: functions.CreateUPSE4,
        }
      ],
    },
    {
      name: "Modificación o reprogramación",
      pages: [
        /*{
          name: "UPSE 1 Actividades",
          link: "#",
          mobile: true,
          access: functions.CreateActivity,
        },*/
        {
          name: "UPSE 8 Reprogramación metas físicas",
          link: "/UPSE8Agregar",
          mobile: true,
          access: functions.CreateUPSE8,
        }
      ],
    },
    {
      name: "Generación de informe",
      pages: [
        // { name: "UPSE 1 Actividades", link: "#" },
        { name: "UPSE 2 Metas físicas", link: "/UPSE2", access: functions.ViewUPSE2 },
        {
          name: "UPSE 4 Informe mensual",
          link: "#",
          mobile: true,
          access: functions.ViewUPSE4,
          childs: [
            { name: "Informe mensual de metas físicas", link: "/UPSE4" },
            { name: "Pendientes de revisión", link: "/UPSE4Pendientes" }
          ]
        },
        { name: "UPSE 8 Reprogramación metas físicas", link: "/UPSE8", access: functions.ViewUPSE8 }
        /*{ name: "Departamental", link: "/RptDepartamentalMenu" },
        { name: "Productos", link: "/RptProductosMenu" },
        { name: "Presupuesto Ejecutado", link: "/RptPresupuestoMenu" },
        { name: "Cumplimiento de UPSE-2", link:"/RptCumplimientos2"},
        { name: "Cumplimiento de UPSE-4", link:"/RptCumplimientos"}*/
      ],
    },
  ];

  if (loading) {
    setDesktopPages(
      pages
        .map((group) => {
          return {
            name: group.name,
            pages: group.pages
              .map((page) => {
                if (!page.access || validateFunction(user, page.access)) {
                  return page;
                } else {
                  return undefined;
                }
              })
              .filter((page) => {
                return page !== undefined;
              }),
          };
        })
        .filter((group) => {
          return group.pages.length > 0;
        })
    );

    setMobilePages(
      pages
        .map((group) => {
          return {
            name: group.name,
            pages: group.pages
              .map((page) => {
                if (
                  (!page.access || validateFunction(user, page.access)) &&
                  page.mobile
                ) {
                  return page;
                } else {
                  return undefined;
                }
              })
              .filter((page) => {
                return page !== undefined;
              }),
          };
        })
        .filter((group) => {
          return group.pages.length > 0;
        })
    );
    setLoading(false);
  }

  function validateToken() {
    if (!localStorage.getItem(config.user_id)) {
      //undefined
      console.error({
        title: "ERROR",
        text: "Se debe iniciar sesión en el sitio antes de ingresar a esta página.",
      });
      setDialog({
        title: "ERROR",
        text: "Se debe iniciar sesión en el sitio antes de ingresar a esta página.",
      });
      setOpenDialog(true);
      setTimeout(() => {
        navigate("/Login");
      });
      setValidToken(true);
    } else {
      instance
        .post("/auth/validateToken")
        .then((res) => {
          if (res.data) {
            let user = res.data.user;
            user = {
              ...user,
              fotografia: config.profile_url + user.fotografia,
            };
            setUserInfo(user);
            setValidToken(true);
          }
        })
        .catch((err) => {
          alert("La sesión ha caducado por favor inicar sesión nuevamente.");
          logout();
        })
        .finally();
    }
  }

  useEffect(() => {
    validateToken();

    const storedIndex = localStorage.getItem('selectedIndex');
    if (storedIndex !== null) {
      setSelectedIndex(Number(storedIndex)); // asegúrate de convertirlo a número si lo necesitas como índice
    }
  }, []);

  useEffect(() => {
    if (selectedIndex !== null) {
      localStorage.setItem('selectedIndex', selectedIndex);
    }
  }, [selectedIndex]);


  return (
    <>
      <AppBar position="sticky" className="AppBarItem">
        <Container maxWidth="xl" className="AppBarItem">
          <Toolbar disableGutters className="AppBarContainer AppBarItem">
            <Box
              className="AppBarItem"
              sx={{
                flexGrow: 1,
                display: { xs: "flex", sm: "none" },
                right: 0,
              }}
            >
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleChange}
                color="inherit"
              >
                <MenuIcon
                  sx={{ display: { xs: "flex", sm: "none" } }}
                  className="MenuIcon"
                />
              </IconButton>
            </Box>
            <Box
              sx={{
                width: { xs: "100%", sm: "10%" },
                display: { xs: "flex" },
                justifyContent: { xs: "center" },
              }}
            >
              <Link href="/Homepage" className="nav-logo" onClick={() => setSelectedIndex(-1)}>
                <Box
                  component="img"
                  //Se agrega a mano porque no respeta la clase
                  sx={{
                    cursor: "pointer",
                    width: "74px",
                    height: "51px",
                  }}
                  src={require("../imgs/icta.png")}
                  alt="Icta Logo"
                />
              </Link>
            </Box>
            <Grid
              container
              className="AppBarItem"
              sx={{ display: { xs: "none", sm: "block" } }}
            >
              <Grid item className="AppBarItem">
                {desktopPages.map((item, index) => (
                  <AppBarOption
                    className="AppBarOption"
                    title={item.name}
                    options={item.pages}
                    index={index}
                    handleClick2={handleClick2}
                    selectedIndex={selectedIndex}
                    key={index}
                  />
                ))}
              </Grid>
            </Grid>
            <div style={{ marginRight: '10px' }}>
              <AppBarNotification />
            </div>

            <Box className="AppBarItem">
              <Tooltip title="Abrir configuración" className="AppBarAvatar">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" src={userInfo.fotografia} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting, index) => (
                  <MenuItem key={setting + index} onClick={handleCloseUserMenu}>
                    <Link
                      textAlign="center"
                      href={setting.link}
                      className="UserMenu"
                    >
                      {setting.name}
                    </Link>
                  </MenuItem>
                ))}
                <MenuItem onClick={handleLogOut}>Cerrar sesión</MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Box className="MobileMenuContainer inactive" xs={12}>
        <Collapse orientation="horizontal" in={checked} sx={{ width: "100%" }}>
          {mobilePages.map((item, index) => (
            <Accordion
              sx={{ margin: "0" }}
              disableGutters
              style={{ boxShadow: "none" }}
              easing={{ enter: 1000, exit: 2000 }}
              key={item + index}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{item.name}</Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Grid container direction="column">
                  {item.pages.map((page, pageindex) => (
                    <ListItem
                      button
                      key={page + pageindex}
                      onClick={() => {
                        navigate(page.link);
                        handleChange();
                      }}
                    >
                      <ArrowForwardIosIcon sx={{ scale: "0.65" }} />
                      <Typography>{page.name}</Typography>
                    </ListItem>
                  ))}
                </Grid>
              </AccordionDetails>
            </Accordion>
          ))}
        </Collapse>
      </Box>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </>
  );
}
export { AppBarComponent };
